import { CreateCategoryRequest, CreateCategoryResponse, Category } from '@/types/model';
import { apiClient, QueryParams, PaginatedResponse } from './apiClient';

export interface CategoriesQueryParams extends QueryParams {
  type?: string;
  active?: boolean;
}

export const categoryService = {
  /**
   * Get categories with pagination, search, and filtering
   */
  async getCategories(params: CategoriesQueryParams = {}): Promise<PaginatedResponse<Category>> {
    return apiClient.getPaginated<Category>('/categories', params);
  },

  /**
   * Get a single category by ID
   */
  async getCategoryById(id: string): Promise<Category> {
    return apiClient.getById<Category>('/categories', id);
  },

  /**
   * Create a new category
   */
  async createCategory(categoryData: CreateCategoryRequest): Promise<CreateCategoryResponse> {
    return apiClient.create<CreateCategoryRequest, CreateCategoryResponse>('/categories', categoryData);
  },

  /**
   * Update a category
   */
  async updateCategory(id: string, categoryData: Partial<CreateCategoryRequest>): Promise<CreateCategoryResponse> {
    return apiClient.update<Partial<CreateCategoryRequest>, CreateCategoryResponse>('/categories', id, categoryData);
  },

  /**
   * Delete a category
   */
  async deleteCategory(id: string, force: boolean = false): Promise<{ success: boolean; message: string }> {
    return apiClient.delete<{ success: boolean; message: string }>(`/categories/${id}`, {
      params: { force },
    });
  },

  /**
   * Toggle category active status
   */
  async toggleCategoryStatus(id: string, active: boolean): Promise<CreateCategoryResponse> {
    return apiClient.toggleStatus<CreateCategoryResponse>('/categories', id, active);
  },

  /**
   * Update category display order
   */
  async updateCategoryDisplayOrder(id: string, displayOrder: number): Promise<CreateCategoryResponse> {
    return apiClient.patch<CreateCategoryResponse>(`/categories/${id}/display-order`, { displayOrder });
  },
};
